var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{ref:"loadIcon",attrs:{"data-action":"reload"},on:{"click":_vm.emitSearch}})
}
var staticRenderFns = []

export { render, staticRenderFns }